<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>Subscribtion</v-card-title>
        <v-card-text>
          <v-layout align-center>
            <v-flex xs3>
              <v-text-field placeholder="ID" hide-details></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-btn color="purple" dark>edit</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ckeck-subscribrion",

  data: () => ({})
};
</script>

<style lang="scss" scoped>
.v-card__title {
  background-color: #383838;
  color: #fff;
}
</style>
